import { AppRoutes } from '@/routes';
import { HelmetComponent } from './components/shared/Helmet';

const App = (): JSX.Element => (
  <>
    <HelmetComponent />
    <AppRoutes />
  </>
);

export default App;
